<template>
  <ion-app>
    <div v-if="!isLoading">
      <ion-router-outlet />
    </div>
  </ion-app>
</template>

<script setup lang="ts">
  import { IonApp, IonRouterOutlet } from '@ionic/vue';
  import { ref, watch } from 'vue';
  import { useBooking } from './composables/useBooking';
  import { useAuthStore } from './stores/auth-store';
  import { storeToRefs } from 'pinia';
  import { useNotifications } from './composables/useNotifications';
  import { ProfileStore, useProfileStore } from '@/stores/profile-store';
  import { i18n } from '@/plugins/i18n';
  import { Capacitor } from '@capacitor/core';
  import { getLanguageCode } from '@/plugins/device';

  const { handleGetLastBooking } = useBooking();
  const { handleGetNotifications } = useNotifications();

  const { token } = storeToRefs(useAuthStore());
  const isLoading = ref(true);

  const success = function (message: string) {
    console.log('Se inició clarity', message);
  };
  const failure = function (message: string) {
    console.log('Hubo un error con clarity', message);
  };

  declare let ClarityPlugin: any;
  if (Capacitor.getPlatform() === 'android') {
    ClarityPlugin.initialize('qttwzufhvo', success, failure, { isIonic: true });
  }

  const getLastBooking = async () => {
    try {
      await handleGetLastBooking();
    } catch (error) {
      console.log('not booked', error);
    }
  };

  const profileStore: ProfileStore = useProfileStore();
  const { languageSelected } = storeToRefs(profileStore);

  /* Si el usuario está logueado, usamos su idioma del perfil */
  const initialConfig = async () => {
    i18n.global.locale.value = languageSelected.value;
    if (token.value !== '') {
      try {
        isLoading.value = true;
        await getLastBooking();
        await handleGetNotifications();
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    } else {
      /* Si el usuario no está logueado, obtenemos el idioma del dispositivo */
      try {
        const response = await getLanguageCode();
        const deviceLanguage = response.value;
        i18n.global.locale.value = deviceLanguage.split('-')[0];
      } catch (error) {
        console.error(error);
        i18n.global.locale.value = 'en';
      } finally {
        isLoading.value = false;
      }
    }
  };

  initialConfig();

  watch(token, () => {
    initialConfig();
  });
</script>
